import styled from 'styled-components'
import { theme } from '@/client/components'
const { borders, color, space, breakpoint } = theme

export const Featured = styled.div`
  padding-bottom: ${space.xl3};

  @media (min-width: ${breakpoint.lg}) {
    padding: ${space.lg} 0 ${space.xl3};
  }
`

export const MainFeatured = styled.div`
  @media (min-width: ${breakpoint.lg}) {
    padding-top: ${space.xl3};
  }
`

export const CleanCard = styled.div`
  width: calc(100% + ${space.xl3});
  margin-left: -${space.lg};
  margin-bottom: ${space.xl2};
  padding: ${space.xl3} ${space.xl} ${space.xl};
  background-color: ${color.grayscale.light};

  @media (min-width: ${breakpoint.lg}) {
    width: auto;
    margin-left: 0;
    margin-bottom: 0;
    padding: ${space.xl3} ${space.xl} ${space.xl2};
    border-radius: ${borders.radius.lg};
  }
`

export const Video = styled.video`
  width: 100%;
  height: auto;
`

export const SampleBookImage = styled.div`
  position: relative;
  width: 100%;

  img {
    display: block;
    max-width: 100%;
    height: auto;
  }
`
